import { onMounted, onBeforeUnmount } from 'vue';
import { isFirefox } from '@/Utils/Browser';
import WebStorage, { storageTypes } from '@/Utils/WebStorage';

// Firefox-only workaround (#25641, 2025): persists scroll position so it is
// restored when navigating back. No-op on other browsers.
// NEEDS REVIEW: verify it's still needed in current Firefox; if so it likely
// belongs in one central place, not a per-view composable.
export const useScrollRestoration = (scrollKey = 'scrollPosition') => {
    if (!isFirefox) {
        return;
    }

    const storage = new WebStorage(scrollKey, storageTypes.sessionStorage);
    const saveScrollPosition = () => storage.set(window.scrollY);

    onMounted(() => {
        const y = storage.get();
        if (y !== null) {
            setTimeout(() => {
                window.scrollTo(0, y);
            }, 0);
        }
        window.addEventListener('beforeunload', saveScrollPosition);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('beforeunload', saveScrollPosition);
    });
};
